import { useEffect, useState } from 'react';
import { statusOrder } from 'src/features/locations/scheduleLocationGroupPage/modules/LocationSchedulePageTable/LocationSchedulePageTable.hook';
import { useParamQuery } from 'src/hooks';
import { AssemblyStatus, IMappedLocationGroupDaypart } from 'src/interfaces';
import { formatDate } from 'src/utils';
import { formatTimestamp } from 'src/utils/date';

export const useOOLocationScheduleTable = (
  tableData: IMappedLocationGroupDaypart[],
  isSortModified: boolean,
) => {
  const { getParamsValue } = useParamQuery();
  const locationGroupId = getParamsValue('groupID').join();

  const [sortTableData, setSortTableData] = useState<
    IMappedLocationGroupDaypart[]
  >([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setSortTableData([]);

      return;
    }

    // Loop through the table data and format the dates
    let formattedData = tableData.map((item) => ({
      ...item,
      startDate: formatDate(item.startDate),
      endDate: formatDate(item.endDate),
      assemblyScheduleDate:
        formatTimestamp(item?.assemblyScheduleDate || '') || '',
      status: item.status || AssemblyStatus.EXPIRED,
    }));

    // Only sort by status when no other table sorting is active
    if (!isSortModified) {
      formattedData = formattedData.sort(
        (a, b) => statusOrder[a.status] - statusOrder[b.status],
      );
    }

    setSortTableData(formattedData);
  }, [tableData, isSortModified]);

  return {
    locationGroupId,
    sortTableData,
  };
};
